module.exports = __webpack_public_path__ + "img/user-for-openbadge-1.11cf8c0b.png";